const pl = require('./pl.json');

export function getText(phrase: string): string {
    try {
        let result = pl;

        phrase.split('.').forEach((snippet) => {
            result = result[snippet];
        });

        return typeof result === 'string'
            ? result
            : '';
    } catch {
        return '';
    }
}
